import React, { useEffect, useState } from "react";
import getJsonFromApi from "../Common/getJsonFromApi";

export default function FrameTopNav() {
  const [username, setUsername] = useState(sessionStorage.getItem("username"));
  const [manageProfileUrl, setManageProfileUrl] = useState('');
  const [isIDSuser, setIsIDSUser] = useState(false);
  const [clientId, setClientId] = useState('');
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    let mounted = true;
    getJsonFromApi("/users/current").then((result) => {
      if (mounted) {
        const username = (result && result.username) || null;
        sessionStorage.setItem("username", username);
        setUsername(username);

        const clientId = (result && result.clientId) || null;
        setClientId(clientId);

        const clientName = (result && result.clientName) || null;
        setClientName(clientName);

        if(result)
        {
          setManageProfileUrl(result.manageProfileUrl);
          setIsIDSUser(result.isIDSUser);
        }
      }
    });

    return () => (mounted = false);
  }, []);
  return (
    <React.Fragment>
      <div className="header navbar navbar-inverse navbar-fixed-top">
        {/* BEGIN TOP NAVIGATION BAR */}
        {/* BEGIN LOGO */}
        <img
          className="navbar-brand"
          src="/content/img/food_white.svg"
          alt=""
        />
        <span className="admin-headquarters">
          |&nbsp;&nbsp;{clientId} - {clientName} - Admin Portal
        </span>
        {/* END LOGO */}
        {/* BEGIN RESPONSIVE MENU TOGGLER */}
        <a
          className="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <img src="/content/themes/assets/img/menu-toggler.png" alt="" />
        </a>
        {/* END RESPONSIVE MENU TOGGLER */}
        {/* BEGIN TOP NAVIGATION MENU */}
        <ul className="nav navbar-nav pull-right">
          {/* BEGIN NOTIFICATION DROPDOWN */}
          {/* END NOTIFICATION DROPDOWN */}
          {/* BEGIN TODO DROPDOWN */}
          {/* END TODO DROPDOWN */}
          {/* BEGIN USER LOGIN DROPDOWN */}
          <li className="dropdown user">
            <a
              href="#"
              data-toggle="modal"
              data-target="#About"
              className="dropdown-toggle"
            >
              <i
                className="fa fa-info-circle fa-2x"
                style={{ marginTop: "5px" }}
              />
              <span className="username margin" style={{ marginTop: "5px" }}>
                About
              </span>
            </a>
            <ul className="dropdown-menu">
              <li>
                <a href="/Account/Login">
                  <i className="fa fa-key" /> Log Out
                </a>
              </li>
            </ul>
          </li>
          <li className="separator dropdown user">
            <a
              href="#"
              className="dropdown-toggle"
              data-toggle="dropdown"
              data-hover="dropdown"
              data-close-others="true"
            >
              <i className="fa fa-user fa-2x" />
              <span className="username margin">{username}</span>
              <i className="fa fa-angle-down margin" />
            </a>
            
            <ul className="dropdown-menu">
               { isIDSuser && 
              <li>
              <a target="_blank" href={manageProfileUrl}>
                  <i className="fa fa-cog" aria-hidden="true"></i>Manage Profile
                  </a>
                </li> }  
              <li>
                <a href="/Account/Login">
                  <i className="fa fa-key" /> Log Out
                </a>
              </li>
             
            </ul>
          </li>
          {/* END USER LOGIN DROPDOWN */}
        </ul>
        {/* END TOP NAVIGATION MENU */}
        {/* END TOP NAVIGATION BAR */}
      </div>
      <div className="clearfix"></div>
    </React.Fragment>
  );
}
